<template>
    <div class="add_newAddResourse_mask"  v-if="addShow">
    <el-card class="newAdd_account">
        <div slot="header" class="clearfix" style="text-align:center;">
            <span style="line-height: 36px;" v-if='curType==1'>添加等级</span>
            <span style="line-height: 36px;" v-if='curType!=1'>编辑等级</span>
        </div>
        <!--<div>
            <el-radio-group v-model="myType" style="margin-bottom: 20px;" @change="changeType">
                <el-radio-button :label="0" v-if="myType==0">图片</el-radio-button>
                <el-radio-button :label="1" v-if="myType==1">视频</el-radio-button>
            </el-radio-group>
        </div>-->
        <div class="resourseContent">
            <p>
                <span class="col-lg-3">等级名：</span><el-input class="col-lg-4" v-model="myfxLevelObj.name"></el-input>
            </p>
            <p>
                <span class="col-lg-3">自购数量：</span><el-input class="col-lg-4" v-model="myfxLevelObj.selfSale"></el-input><span class="col-lg-3">台</span>
            </p>
            <p>
                <span class="col-lg-3">直销数量：</span><el-input class="col-lg-4" v-model="myfxLevelObj.directSale"></el-input><span class="col-lg-3">台</span>
            </p>

            <p>
                <span class="col-lg-3">团队销量：</span><el-input class="col-lg-4" v-model="myfxLevelObj.teamSale"></el-input><span class="col-lg-3">台</span>
            </p>
            <p>
                <span class="col-lg-3">直营分润：</span><el-input class="col-lg-4" v-model="myfxLevelObj.directSaleFee"></el-input><span class="col-lg-3">元</span>
            </p>
            <p>
                <span class="col-lg-3">同级分润：</span><el-input class="col-lg-4" v-model="myfxLevelObj.sLevelFee"></el-input><span class="col-lg-3">元</span>
            </p>
            <p>
                <span class="col-lg-3">级差分润：</span><el-input class="col-lg-4" v-model="myfxLevelObj.levelFee"></el-input><span class="col-lg-3">元</span>
            </p>
            <p>
                <span class="col-lg-3">分润：</span><el-input class="col-lg-4" v-model="myfxLevelObj.shareFee"></el-input><span class="col-lg-3">元</span>
            </p>


            <p style="text-align:center;"><el-button type="success" @click="commit" style="width: 240px;">提交</el-button></p>
        </div>
        <span @click="boxColose" style="position: absolute; top: 0;right:0;padding:10px;color:#FF4949"><i class="el-icon-close Danger"></i></span>
    </el-card>
    </div>
</template>
<script>
    import $ajax from '../../https/config'
    export default {
      props: ['addShow', 'curType', 'fxId', 'name','selfSale', 'directSale', 'teamSale','directSaleFee','levelFee','fxLevelObj'],
      data () {
        return {
          labelPosition: 'right',
          loading: false,
          fileList: [],
          fileNum: 0,
          form: {},
          title: '',
          content: '',
          img: '',
          myType: this.curType,
          isMultiple: true,
          token: '',
          editname:'',
          editselfSale:0,
          editdirectSale:0,
          editteamSale:0,
          editdirectSaleFee:0,
          editlevelFee:0,
          editfxLevelObj:{}
        }
      },
      computed: {
        myname: {
          get: function () {
            this.editname = this.name
            return this.name
          },
          set: function (val) {
            this.editname = val
          }
        },
        myselfSale: {
          get: function () {
            this.editselfSale = this.selfSale
            return this.selfSale
          },
          set: function (val) {
            this.editselfSale = val
          }
        },
        mydirectSale: {
          get: function () {
            this.editdirectSale = this.directSale
            return this.directSale
          },
          set: function (val) {
            this.editdirectSale = val
          }
        },
        myteamSale: {
          get: function () {
            this.editteamSale = this.teamSale
            return this.teamSale
          },
          set: function (val) {
            this.editteamSale = val
          }
        },
        mydirectSaleFee: {
          get: function () {
            this.editdirectSaleFee = this.directSaleFee
            return this.directSaleFee
          },
          set: function (val) {
            this.editdirectSaleFee = val
          }
        },
        mylevelFee: {
          get: function () {
            this.editlevelFee = this.levelFee
            return this.levelFee
          },
          set: function (val) {
            this.editlevelFee = val
          }
        },
        myfxLevelObj: {
          get: function () {
            console.log("after:"+JSON.stringify(this.fxLevelObj));
            this.editfxLevelObj = this.fxLevelObj
            //this.editfxLevelObj.shareFee = this.fxLevelObj.shareFee/100
            return this.fxLevelObj
          },
          set: function (val) {
            this.editfxLevelObj = val
          }
        }
      },
      created: function () {
        //this.getUpToken()
      },
      methods: {
        boxColose () {
          this.$emit('closeAddAccount', false)
        },
        commit () {
          var tType
          var that = this

          this.editfxLevelObj.shareFee = this.editfxLevelObj.shareFee*100
          var params = this.editfxLevelObj
          if (this.editfxLevelObj.name.trim() === '') {
            that.$message({
              type: 'error',
              message: '名字不能为空'
            })
            return
          }

          var url = '/fx/level/add'
          if (this.curType!=1){
            url = '/fx/level/update'
          }

          $ajax.post(url, params, 'headers', function (res) {
            if (res.resultStatus === true) {
              that.$message({
                type: 'success',
                message: '操作分销等级成功！'
              })
              that.boxColose()
            }
          }, function () {
          })
        }
      }
    }
</script>
<style lang="scss">
  .add_newAddResourse_mask {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 100;
      text-align: center;

  .newAdd_account {
    min-height: 530px;
    width: 500px;
    top: 20%;
    left: 45%;
    z-index: 101;
    margin-left: -200px;
    position: fixed;

    .el-card__header {
        padding: 10px
    }
    .el-tabs__header {
        margin-bottom: 0;
    }
    .resourseContent {
        text-align: left;
    }
    .col-lg-3 {
        width: 20%;
        display: inline-block;
        font-weight: 700;
        color: #777;
        vertical-align: top;
    }
    .col-lg-4 {
        width: 60%;
        display: inline-block;

        textarea {
          height: 120px;
        }
    }

  }
  }
</style>



// WEBPACK FOOTER //
// src/page/fxshop/fxLevelAdd.vue